var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1021 2.70425C10.4472 2.70425 10.7271 2.98408 10.7271 3.32925L10.7271 13.3634C10.7271 13.7086 10.4472 13.9884 10.1021 13.9884C9.75687 13.9884 9.47705 13.7086 9.47705 13.3634L9.47705 3.32925C9.47705 2.98408 9.75687 2.70425 10.1021 2.70425Z",
    fill: "#323F48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9733 10.4808C13.2178 10.7244 13.2187 11.1201 12.9751 11.3647L10.5451 13.8047C10.4278 13.9225 10.2684 13.9887 10.1022 13.9887C9.93602 13.9887 9.77666 13.9225 9.65938 13.8047L7.22938 11.3647C6.9858 11.1201 6.98662 10.7244 7.23119 10.4808C7.47577 10.2373 7.8715 10.2381 8.11508 10.4826L10.1022 12.478L12.0894 10.4826C12.333 10.2381 12.7287 10.2373 12.9733 10.4808Z",
    fill: "#323F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1851 10.3442C17.1851 8.99256 16.0906 7.89833 14.7401 7.89833H13.9626C13.6174 7.89833 13.3376 7.61851 13.3376 7.27333C13.3376 6.92815 13.6174 6.64833 13.9626 6.64833H14.7401C16.7812 6.64833 18.4351 8.30243 18.4351 10.3442V14.4142C18.4351 16.451 16.7844 18.1017 14.7476 18.1017H5.46422C3.42321 18.1017 1.76839 16.4468 1.76839 14.4058V10.335C1.76839 8.29876 3.4201 6.64833 5.45589 6.64833H6.24089C6.58607 6.64833 6.86589 6.92815 6.86589 7.27333C6.86589 7.61851 6.58607 7.89833 6.24089 7.89833L5.45589 7.89833C4.11002 7.89833 3.01839 8.98956 3.01839 10.335L3.01839 14.4058C3.01839 15.7565 4.11357 16.8517 5.46422 16.8517H14.7476C16.094 16.8517 17.1851 15.7607 17.1851 14.4142V10.3442Z",
    fill: "#323F48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d9d943ced7cf3d1e00e7bd2868038e75.svg";
export { ForwardRef as ReactComponent };